import type { ComponentPropsWithRef, ReactNode } from 'react'
import cx from 'classnames'
import styles from './SearchResultItem.module.css'
import { Icon } from '@/components/Icon'

export interface SearchResultItemProps extends ComponentPropsWithRef<'div'> {
  children?: ReactNode
  visual?: ReactNode
  highlighted: boolean
  selected: boolean
  testId?: string
}

/**
 * An item in a list of search results.
 */
export function SearchResultItem({
  children,
  visual,
  highlighted,
  className,
  selected,
  testId,
  ...rest
}: SearchResultItemProps) {
  return (
    <div
      data-test={testId}
      className={cx(
        className,
        styles.root,
        highlighted && styles.highlighted,
        selected && styles.selected,
      )}
      {...rest}
    >
      {visual && <div className={styles.visual}>{visual}</div>}
      <div className={styles.text}>{children}</div>
      <div className={cx(styles.checkedContainer, selected && styles.selected)}>
        <Icon auto name="tick" />
      </div>
    </div>
  )
}
